import { useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Outlet } from '@tanstack/react-router';
import type { FC } from 'react';

import { Footer } from '../../components/molecules/footer';
import { Navbar } from '../../components/organisms/navbar';
import { Sidebar } from '../../components/organisms/sidebar';
import { useSettings } from '../../contexts/settings-context';

const LayoutRoot = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  minHeight: '100%',
  paddingTop: 64,
}));

const LayoutContent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 64px)',
}));

export const Layout: FC = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { settings, saveSettings } = useSettings();

  const handlePinSidebar = (): void => {
    saveSettings({
      ...settings,
      pinSidebar: !settings.pinSidebar,
    });
  };

  return (
    <LayoutRoot>
      <Navbar />
      {!mdDown && <Sidebar onPin={handlePinSidebar} pinned={settings.pinSidebar} />}
      <LayoutContent
        sx={{
          ml: {
            md: settings.pinSidebar ? '270px' : '73px',
          },
        }}>
        <Outlet />
        <Footer />
      </LayoutContent>
    </LayoutRoot>
  );
};
